import SearchChips from 'components/SearchChips/SearchChips';
import SectionHeader from 'components/SectionHeader/SectionHeader';
import SelectBatterTeam from 'components/SearchInputs/SelectBatterTeam';
import SelectBatters from 'components/SearchInputs/SelectBatters';
import SelectLevel from 'components/SearchInputs/SelectLevel';
import SelectTimePeriod from 'components/SearchInputs/SelectTimePeriod';
import usePlayerReportBatter from 'hooks/PlayerReport/Batter/usePlayerReportBatter';
import { useReportId } from 'hooks/helperHooks';
import { useTranslation } from 'react-i18next';
import SelectGameType from 'components/SearchInputs/SelectGameType';

type Props = {
  isSearchCriteriaOpen: boolean;
  setSearchCriteriaOpen: () => void;
};

const BatterSearchCriteria = ({ isSearchCriteriaOpen, setSearchCriteriaOpen }: Props) => {
  const { isCreate } = useReportId();

  const { searchCriteria, setSearchCriteria, searchChips } = usePlayerReportBatter();

  const { t } = useTranslation();

  return (
    <>
      <SectionHeader
        isOpen={isSearchCriteriaOpen}
        onClick={isCreate ? setSearchCriteriaOpen : undefined}
        title={t('Populate report')}
        isEnabled={isCreate}
      />
      {isSearchCriteriaOpen ? (
        <div className='report-layout-shelf-section'>
          <SelectGameType
            selectedGameTypeId={searchCriteria.gameType?.id}
            onChange={(gameType) =>
              setSearchCriteria({
                gameType,
                dateRanges: undefined,
                seasonNames: undefined,
                level: undefined,
                team: undefined,
                players: undefined,
              })
            }
          />
          <SelectTimePeriod
            selectedSeasonNames={searchCriteria.seasonNames}
            onChange={(seasonNames, dateRanges) =>
              setSearchCriteria({
                dateRanges,
                seasonNames,
                level: undefined,
                team: undefined,
                players: undefined,
              })
            }
          />
          <SelectLevel
            selectedLevelId={searchCriteria.level?.id}
            onChange={(level) =>
              setSearchCriteria({
                level,
                team: undefined,
                players: undefined,
              })
            }
            dateRanges={searchCriteria.dateRanges}
            gameType={searchCriteria.gameType?.id}
          />
          <SelectBatterTeam
            selectedTeamId={searchCriteria.team?.id}
            onChange={(team) =>
              setSearchCriteria({
                team,
                players: undefined,
              })
            }
            dateRanges={searchCriteria.dateRanges}
            levelId={searchCriteria.level?.id}
            gameType={searchCriteria.gameType?.id}
          />
          <SelectBatters
            selectedBatters={searchCriteria.players}
            onChange={(players) => setSearchCriteria({ players })}
            dateRanges={searchCriteria.dateRanges}
            levelId={searchCriteria.level?.id}
            teamId={searchCriteria.team?.id}
          />
        </div>
      ) : (
        searchChips.dateRanges && (
          <SearchChips
            seasonNames={searchChips.seasonNames}
            dateRanges={searchChips.dateRanges}
            otherChips={{ ...searchChips, dateRanges: undefined, seasonNames: undefined }}
          />
        )
      )}
    </>
  );
};

export default BatterSearchCriteria;
